import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineMail } from 'react-icons/hi';
import { BsTelephone } from 'react-icons/bs';
import { AiOutlineLinkedin } from 'react-icons/ai';

import logo from '../../../imgs/logo-tile.png';
import { useSettings } from '../../../context/SettingsContext';

import './Footer.scss';

export const Footer = () => {
  const { t } = useSettings();
  const year = new Date().getFullYear();
  const f = t.footer;

  return (
    <footer className="ds-footer">
      <div className="ds-container ds-footer__grid">
        <div className="ds-footer__brand">
          <Link to="/" className="ds-footer__logo">
            <img src={logo} alt="DS-Innovation" width={40} height={40} />
            <span>DS-Innovation</span>
          </Link>
          <p>{f.tagline}</p>
        </div>

        <nav className="ds-footer__col" aria-label={f.exploreTitle}>
          <h4>{f.exploreTitle}</h4>
          <Link to="/">{f.links.home}</Link>
          <Link to="/services">{f.links.services}</Link>
          <Link to="/work">{f.links.work}</Link>
          <Link to="/about">{f.links.about}</Link>
          <Link to="/contact">{f.links.contact}</Link>
        </nav>

        <div className="ds-footer__col">
          <h4>{f.contactTitle}</h4>
          <a href="mailto:daniel.savin@ds-innovation.dev">
            <HiOutlineMail aria-hidden="true" /> daniel.savin@ds-innovation.dev
          </a>
          <a href="tel:+32483256610">
            <BsTelephone aria-hidden="true" /> +32 483 25 66 10
          </a>
          <a href="https://www.linkedin.com/company/ds-innovation" target="_blank" rel="noopener noreferrer">
            <AiOutlineLinkedin aria-hidden="true" /> LinkedIn
          </a>
          <span className="ds-footer__location">{f.location}</span>
        </div>
      </div>

      <div className="ds-container ds-footer__legal">
        <span>© {year} DS-Innovation BV</span>
        <span>BE 1001.488.871</span>
      </div>
    </footer>
  );
};

export default Footer;
